import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 420px;
  padding: 32px 24px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.16);
  gap: 18px;
  backdrop-filter: blur(10px);

  img {
    width: 220px;
    margin: 0 auto 8px;
    max-width: 70%;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  @media only screen and (min-width: 600px) {
    max-width: 440px;
    padding: 36px 28px;
  }

  @media only screen and (min-width: 960px) {
    max-width: 480px;
    padding: 40px 32px;
  }
`;

export const PageCaption = styled.span`
  font-weight: 700;
  font-size: 20px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #1e958c;
`;

export const VersionCode = styled.span`
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  color: #ab0505;
  opacity: 0.8;
`;

